import { useEffect, useState } from 'react';

/** Reactive matchMedia. SSR-safe (false until mounted). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    try {
      return window.matchMedia(query).matches;
    } catch {
      return false;
    }
  });
  useEffect(() => {
    let mql: MediaQueryList;
    try {
      mql = window.matchMedia(query);
    } catch {
      return;
    }
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}

/**
 * Is there room to dock a case beside the list? Below this width a row click
 * navigates to the full case page instead (the phone path is unchanged).
 */
export const DOCK_QUERY = '(min-width: 1100px)';
export function useCanDock(): boolean {
  return useMediaQuery(DOCK_QUERY);
}
